import { type Group } from "@k8slens/lds/lib/es/Select/Select";
import { BusinessWithCurrentPlan } from "src/hooks/useBusinessesWithCurrentPlan";
import { localeSort } from "./locale-sort";

export const activeLBIDGroupId = "active-lbids";
export const activeLBIDGroupLabel = "Active Businesses";

export const inactiveLBIDGroupId = "inactive-lbids";
export const inactiveLBIDGroupLabel = "Inactive Businesses";

type BusinessOption = {
  id: string;
  label: string;
  subtitle?: string;
};

export const lbidOptionsSort = (a: BusinessOption, b: BusinessOption) => localeSort(a.label, b.label);

export const lbidGroupReduce = (
  d: Array<Group<BusinessOption>>,
  { id, name, department, currentPlan }: BusinessWithCurrentPlan,
): [Group<BusinessOption>, Group<BusinessOption>] => {
  const activeGroup = d.find((g) => g.id === activeLBIDGroupId) || {
    id: activeLBIDGroupId,
    label: activeLBIDGroupLabel,
    options: [],
  };
  const inactiveGroup = d.find((g) => g.id === inactiveLBIDGroupId) || {
    id: inactiveLBIDGroupId,
    label: inactiveLBIDGroupLabel,
    options: [],
  };

  // Only businesses with current (active) pro or enterprise plans are considered active
  if (currentPlan !== null && (currentPlan.type === "pro" || currentPlan.type === "enterprise")) {
    activeGroup.options.push({ id, label: name, subtitle: department });
  } else {
    inactiveGroup.options.push({ id, label: name, subtitle: department });
  }
  activeGroup.options = activeGroup.options.sort(lbidOptionsSort);
  inactiveGroup.options = inactiveGroup.options.sort(lbidOptionsSort);

  return [activeGroup, inactiveGroup];
};
